import React from 'react';
import { Box } from '@material-ui/core';

import useStyles from './useStyles';
import Carousel from '../Carousel';
import Button from '../Form/Button';
import Html from '../Html';
import DateHelper from '../../helpers/DateHelper';

export default function CampanhaPublicitaria({ campanhas }) {
  const classes = useStyles();

  if (!campanhas) {
    return null;
  }

  return (
    <Carousel xs={1} sm={2} md={3} showNavOnHoverAll>
      {campanhas?.map((item, key) => (
        <Box key={key} className={classes.item}>
          <h3 className={classes.title}>{item.st_campanhapublicitaria}</h3>
          <h4 className={classes.subtitle}>{DateHelper.toFormatString(item.dt_inicio?.date, "d 'de' MMMM, yyyy")}</h4>
          <Box className={classes.banner}>
            <img src={item.st_urlimagem} alt="" />
          </Box>
          <Box className={classes.content}>
            <Html className={classes.content} html={item.st_conteudo} />
          </Box>
          {Boolean(item.st_link) && (
            <Box align="left">
              <Button color="secondary" variant="text" href={item.st_link} target="_blank">
                <b>saiba mais</b>
              </Button>
            </Box>
          )}
        </Box>
      ))}
    </Carousel>
  );
}
